import { Button, ButtonProps } from '@mui/material'
import { createLink } from '@tanstack/react-router'

const InnerButtonLink: React.FC<
    React.PropsWithChildren<
        {
            ref: React.RefObject<HTMLAnchorElement>
            onClick?: React.MouseEventHandler
        } & Pick<
            ButtonProps,
            'variant' | 'sx' | 'endIcon' | 'startIcon' | 'style'
        >
    >
> = ({ children, ref, onClick, ...props }) => (
    <Button component={'a'} ref={ref} onClick={onClick} {...props}>
        {children}
    </Button>
)

export const ButtonLink = createLink(InnerButtonLink)
